module.exports = __webpack_public_path__ + "images/fa-light-300.b3d910b716a9ddb821eeaf5303b2dc1f.svg";